// extracted by mini-css-extract-plugin
export default {"container":"MoreInfo_container__wfbwM","flexDiv":"MoreInfo_flexDiv__8ydS-","shareEmailBtn":"MoreInfo_shareEmailBtn__aQkV8","emailSvg":"MoreInfo_emailSvg__B1PEJ"};